import React, { useState } from 'react';
import { Modal, Row } from 'antd';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Button, FormDatePicker, FormSubmitButton, MasterDetailForm, Widget } from '@digital/ui';
import * as Yup from 'yup';
import { enviarCartaEsclarecimentoTecnicoFornecedor } from '@app/api/sas/ordemCompra';
import { ordemCompraIdState, reloadVendorListState, dataLimiteEtapaState } from '../atoms';
import { Visibility } from '@app/components';

interface Props {
}

const ModalEnviarCartaEsclarecimentoTecnicoFornecedor = ({ }: Props) => {
  const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const dataLimiteEtapa = useRecoilValue(dataLimiteEtapaState);

  const [exibirModal, setExibirModal] = useState(false);

  const onDiscordar = () => {
    setExibirModal(false);
  };

  const onConcordar = (values: any) => {
    Modal.confirm({
      title: 'Confirmar o Envio?',
      content:
        'Deseja confirmar o envio?',
      cancelText: 'Não',
      onCancel: () => {
        setExibirModal(false);
      },
      okText: 'Sim',
      onOk: () => {
        enviarCartaEsclarecimentoTecnicoFornecedor(ordemCompraId, true, values.dataLimite)
          .then((data: any) => {
            if (data) {
              setReloadVendorList(!reloadVendorList);
            }
          }).finally(() => {
            setExibirModal(false);
          });
      },
    });
  };

  return (
    <>
      <Button
        type="primary"
        style={{ float: 'right', marginRight: '5px' }}
        onClick={() => {
          setExibirModal(true);
        }}>
          solicitar esclarecimentos técnicos
      </Button>
      <Visibility visible={exibirModal} >
        <Modal title="Avançar" width="680px" visible={exibirModal} onCancel={() => setExibirModal(false)} footer={null}>
          <MasterDetailForm
            initialValues={{ dataLimite: undefined }}
            validationSchema={Yup.object().shape({
              dataLimite: Yup.string().nullable().required('Data limite é obrigatória'),
            })}
            actions={[
              <Button key="discordarBtn" type="link" onClick={() => onDiscordar()}>
                Cancelar
              </Button>,
              <FormSubmitButton key="enviarBtn" title="Enviar" noIcon type="primary" onClick={onConcordar} />,
            ]}>
            <Widget>
              <Row>
                <FormDatePicker
                  label="Data Limite de Resposta"
                  name="dataLimite"
                  format="DD/MM/YYYY"
                  span={4}
                  disabledDate={function(current) {
                    if (!dataLimiteEtapa) return false;
                    var limite = new Date(dataLimiteEtapa);
                    limite.setHours(23, 59, 59, 999);
                    return current && current.toDate() > limite;
                  }}
                />
              </Row>
              <Row>
                <p style={{ textAlign: 'center', paddingTop: '20px', paddingBottom: '20px' }}>
                  O formulário dos esclarecimentos técnicos será enviado para todos os fornecedores desta Ordem de Compra.
                </p>
              </Row>
            </Widget>
          </MasterDetailForm>
        </Modal>
      </Visibility>

    </>
  );
};
export default ModalEnviarCartaEsclarecimentoTecnicoFornecedor;
